import { render, staticRenderFns } from "./EventRefetchButton.vue?vue&type=template&id=671485a8"
import script from "./EventRefetchButton.vue?vue&type=script&lang=js"
export * from "./EventRefetchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports